///////////////////////////////////////////////
//        Countdown timer styeling           //
///////////////////////////////////////////////

:host {
  @apply inline-flex;
}
